<div class="main_content">
    <app-breadcrumb></app-breadcrumb>
    <div class="page_main_sec helpSection helpSectiondetails">
        <div class="row">
            <div class="col-2 noPaddingLeft" [ngClass]="{'collapseSidebar': toggle}">
                <div class="vSSec shadowBox" [ngClass]="{'collapseSidebar': toggle}">
                    <div class="vSArrowSec"><i class="bi bi-caret-left sideBarCollapseBtn" (click)="clickEvent('toggle')"></i></div>
                    <div class="vSHeader">
                        <h4>Category</h4>
                    </div>
                    <div class="vSContent" *ngIf="lstHelpData.length > 0">
                        <ul>
                            {{lstHelpData[categoryIndex].category}}
                        </ul>
                    </div>
                </div>
            </div>
            <div class="col-10 noPaddingLeft" [ngClass]="{'collapseSidebar': toggle}">
                <div class="helpAccordian">
                    <div class="accordion processing-accordion" id="accordionExample">
                        <ng-container *ngFor="let doc of lstHelpData;let idx=index;">
                        <div class="accordion-item">
                            <h2  [id]="'heading'+idx">
                                <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                    [attr.data-bs-target]="'#collapse'+idx" [attr.aria-expanded]="idx === 0"
                                    [attr.aria-controls]="'collapse'+idx" [ngClass]="{'collapsed': idx !== 0}">
                                    <h5 class="accordion-header">{{doc.title}}</h5>
                                </button>
                            </h2>
                            <div [id]="'collapse'+idx" class="accordion-collapse collapse" [ngClass]="{'show': idx === 0}"
                                [attr.aria-labelledby]="'heading'+idx" data-bs-parent="#accordionExample">
                                <div class="accordion-body">
                                    <div *ngIf="doc.document_type === 'TEXT'">
                                        <p class="Intro">
                                            {{doc.description}}
                                        </p>
                                    </div>
                                   
                                    <div *ngIf="doc.document_type === 'VIDEO'">
                                        <div class="accordion-body pdfVideo">
                                            <a href="javascript:void(0)" data-bs-toggle='modal' data-bs-target='#video-popup' (click)="videoClick(doc.document_name,doc.document_path)">
                                                <div class="videoImg">
                                                    <img src="../../../assets/img/videos.png" alt="Video">
                                                    <i class="bi bi-play-btn"></i>
                                                </div>
                                            </a>
                                            <div class="videoIntro">
                                                <p>
                                                    {{doc.description}}
                                                </p>
                                                <a href="javascript:void(0)" data-bs-toggle='modal' (click)="videoClick(doc.document_name,doc.document_path)" data-bs-target='#video-popup' class="playVideo">Play Video</a>
                                            </div>
        
                                        </div>
                                    </div>
                                    
                                    <div *ngIf="doc.document_type === 'PDF'">
                                        <div class="accordion-body pdfVideo">
                                            <a href="javascript:void(0)" (click)="downloadFile(doc.document_path)">
                                                <div class="pdfSection">
                                                    <img src="../../../assets/img/pdf-img.png" alt="Image">
                                                    <span><i class="bi bi-filetype-pdf"></i></span>
                                                </div>
                                            </a>
                                            <div class="videoIntro videoIntropdf titlesection">
                                                <p>
                                                    {{doc.description}}
                                                </p>
                                                <!-- <a href={{doc.document_path}} class="playVideo" target="_blank">Download</a> -->
                                                <a href="javascript:void(0)" class="playVideo download" download="{{doc.title}}"
                                                    (click)="download(doc.document_path,doc.title)">Download</a>
                                                <a href="javascript:void(0)" class="playVideo" (click)="downloadFile(doc.document_path)">View Document</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        </ng-container>
                    </div>
                    <!-- <div class="accordion" id="accordionExample">
                                <div *ngIf="doc.document_type == 'TEXT'" class="accordion-item">
                                    <h2 class="accordion-header" id="'heading'+idx">
                                        <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                        [attr.data-bs-target]="'#collapse'+idx" [attr.aria-expanded]="idx==1"
                                            [attr.aria-controls]="'collapse'+idx">
                                            {{doc.title}}
                                        </button>
                                    </h2>
                                    <div [id]="'collapse'+idx" class="accordion-collapse collapse" aria-labelledby="'heading'+idx"
                                        data-bs-parent="#accordionExample">
                                        <div class="accordion-body ">
                                            <p class="Intro">
                                                {{doc.description}}
                                            </p>
                                        </div>
                                    </div>
                                </div>
        
                                <div *ngIf="doc.document_type == 'VIDEO'" class="accordion-item">
                                    <h2 class="accordion-header" id="'heading'+idx">
                                        <button class="accordion-button " type="button" data-bs-toggle="collapse"
                                        [attr.data-bs-target]="'#collapse'+idx" [attr.aria-expanded]="true"
                                        [attr.aria-controls]="'collapse'+idx">{{doc.title}}
                                        </button>
                                    </h2>
                                    <div id="'collapse'+idx" class="accordion-collapse collapse" 
                                        aria-labelledby="'heading'+idx" data-bs-parent="#accordionExample">
                                        <div class="accordion-body pdfVideo">
                                            <a href="javascript:void(0)" data-bs-toggle='modal' data-bs-target='#video-popup' (click)="videoClick(doc.document_name,doc.document_path)">
                                                <div class="videoImg">
                                                    <img src="../../../assets/img/videos.png" alt="Video">
                                                    <i class="bi bi-play-btn"></i>
                                                </div>
                                            </a>
                                            <div class="videoIntro">
                                                <p>
                                                    {{doc.description}}
                                                </p>
                                                <a href="javascript:void(0)" data-bs-toggle='modal' (click)="videoClick(doc.document_name,doc.document_path)"
                                                    data-bs-target='#video-popup' class="playVideo">Play Video</a>
                                            </div>
        
                                        </div>
                                    </div>
                                </div>
        
                                <div *ngIf="doc.document_type == 'PDF'" class="accordion-item">
                                    <h2 class="accordion-header" id="'heading'+idx">
                                        <button class="accordion-button " type="button" data-bs-toggle="'collapse'+idx"
                                            data-bs-target="'#collapse'+idx" [attr.aria-expanded]="true"
                                            aria-controls="'collapse'+idx">{{doc.title}}
                                        </button>
                                    </h2>
                                    <div id="'collapse'+idx" class="accordion-collapse" 
                                        aria-labelledby="'heading'+idx" data-bs-parent="#accordionExample">
                                        <div class="accordion-body pdfVideo">
                                            <a href="javascript:void(0)">
                                                <div class="pdfSection">
                                                    <img src="../../../assets/img/pdf-img.png" alt="">
                                                    <span><i class="bi bi-filetype-pdf"></i></span>
                                                </div>
                                            </a>
                                            <div class="videoIntro videoIntropdf">
                                                <p>
                                                    {{doc.description}}
                                                </p>
                                                <a href="javascript:void(0)" class="playVideo" (click)="openPDF(doc.document_path)">View PDF</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div> -->
                </div>
            </div>

        </div>
    </div>
</div>
<div id="video-popup" tabindex="-1" role="dialog" class="modal article-popup">
    <div role="document" class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 id="exampleModalLabel" class="modal-title">{{videoName}}</h4><a href="#" title="Close this" type="button" data-bs-dismiss="modal" aria-label="Close" class="close sub_close"><span
                        aria-hidden="true"> </span><i class="bi bi-x" (click)="closeVideo()"></i></a>
            </div>
            <div class="modal-body">
                <div class="model_content modal-lg">
                    <div class="contentCustom">
                        <div class="VideoSection">
                            <!-- <img src="../../../assets/img/video.jpg" alt="Video"> -->
                            <video controls #videoPlayer>
                                <source src="{{videoPath}}" type="video/mp4">
                                <source src="mov_bbb.ogg" type="video/ogg">
                                Your browser does not support HTML video.
                            </video>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>